rjm.ui.ChartBuilderCohortTimeOptionsSpecificView = Backbone.View.extend(
 
  initialize: (options) ->
    if not options or not options.cohortDescriptor
      throw "InvalidConstructorArgs - ChartBuilderCohortTimeOptionsSpecificView"

    _.bindAll this, "getCohortList", "save", "setCohortList", "block", "unblock", "generateTemplateData", "render"
    @cohortDescriptor = options.cohortDescriptor
    @cohortList = null

    @listenTo @cohortDescriptor, "change:cohortField", @render

    return

  getCohortList: ->
    _(this.$('#specificCohortSelector').find(':selected')).map (option) ->
      return moment.unix($(option).attr('value')).format("YYYY-MM-DD 00:00:00")

  save: (e) ->
    startTimes = @getCohortList()
    @cohortDescriptor.set 
      startTimes: startTimes
      type: rjm.app.enums.cohortDescriptorType.EXPLICIT
      includeCurrentPeriod: true
    ,
      silent: true 
  
    return

  setCohortList: (cohortList)->
    @cohortList = cohortList

  block: ->
    @$el.addClass "blocked loading"

  unblock: ->
    @$el.removeClass "blocked loading message"

  generateTemplateData: ->
    startDate: @cohortDescriptor.get('startTimes')
    noTimeData: @cohortList is -1

  render: ->
    $(@el).html ich["chartBuilderCohortTimeOptions.specific"](@generateTemplateData())
   
    if @cohortList?
      _(@cohortList).each (cohortDate) =>
        selected = _(@cohortDescriptor.get('startTimes')).find (selectedTime) =>
          selectedStamp = @cohortDescriptor.cleanMoment(moment(selectedTime)).valueOf()/1000
          return +cohortDate.timestamp is +selectedStamp
        this.$('#specificCohortSelector').append('<option value=' + cohortDate.timestamp + ' ' + (if selected then 'selected' else '') + '>' + cohortDate.date + '</option>')
      @unblock()
    else
      @block()

    @$('#specificCohortSelector').multiSelect
      selectableHeader: '<div class="select-header">Available Cohorts</div>'
      selectionHeader: '<div class="select-header">Selected Cohorts</div>'

    return @
)

